module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_0@2x.b1d70fee.png";